// utils/axiosInstance.js
import axios from 'axios';
import { getGuestId, storeGuestIdFromHeaders } from './guestSession';

// Create an Axios instance
const axiosInstance = axios.create({
  headers: {
    "Content-Type": "application/json",
  }
});

axiosInstance.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  const guestId = getGuestId();

  if (token) {
    config.headers.set('Authorization', `Bearer ${token}`);
    config.headers.delete('X-Guest-Id');
  } else {
    config.headers.delete('Authorization');
    if (guestId) config.headers.set('X-Guest-Id', guestId);
  }

  return config;
});

// Response interceptor to handle 401 errors
axiosInstance.interceptors.response.use(response => {
  storeGuestIdFromHeaders(response.headers);
  return response;
}, error => {
  if (error.response && error.response.status === 401 && localStorage.getItem('token')) {
    localStorage.removeItem('token');
    localStorage.removeItem('resume');
    localStorage.removeItem('scope');
    localStorage.removeItem('userId');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('userPhoneNumber');
    window.location.href = '/login';
  }
  return Promise.reject(error);
});

export default axiosInstance;
